<template>
    <div class="mine-page">
        <!-- 个人信息头部 -->
        <div class="profile-hero">
            <div class="profile-content">
                <div class="avatar-wrap">
                    <img class="avatar" :src="avatarSrc" />
                </div>
                <div class="profile-meta">
                    <div class="user-name">{{ userInfo.name || '匿名用户' }}</div>
                    <span class="role-chip">{{ userInfo.userType === 4 ? '平台账号' : '监管用户' }}</span>
                </div>
            </div>
        </div>

        <!-- 基本信息卡（上浮覆盖 hero 底部） -->
        <div class="info-card">
            <div class="card-head">
                <van-icon name="manager-o" class="card-icon" />
                <span class="card-title">基本信息</span>
            </div>
            <div class="card-body">
                <div class="info-row">
                    <span class="ir-label">组织单位</span>
                    <span class="ir-value">{{ userInfo.organizational || '未设置' }}</span>
                </div>
                <div class="info-row">
                    <span class="ir-label">账号有效期</span>
                    <span class="ir-value">{{ formatTime(userInfo.expirationTime) || '长期有效' }}</span>
                </div>
                <div class="info-row">
                    <span class="ir-label">地址</span>
                    <span class="ir-value">{{ userInfo.region || '未设置' }}</span>
                </div>
            </div>
        </div>

        <!-- 退出登录 -->
        <div class="logout-card" @click="handleLogout">
            <van-icon name="warning-o" size="16" />
            <span>退出登录</span>
        </div>

        <!-- 底部版本信息 -->
        <div class="version-info">
            <div class="version-company">湖南星华信息科技有限公司 · 提供技术支持</div>
            <div class="version-no">v1.0.0</div>
        </div>
    </div>
</template>

<script>
import { resourceUrl } from "@/utils/base";

export default {
    name: 'MineView',
    data() {
        return {
            userInfo: {},
            defaultAvatar: require('@/assets/person.jpg'),
        }
    },
    computed: {
        avatarSrc() {
            const apiAvatar = this.getUrl(this.userInfo.avatarUrl);
            return apiAvatar ? apiAvatar : this.defaultAvatar;
        }
    },
    created() {
        const storedUser = window.sessionStorage.getItem('userInfo');
        this.userInfo = storedUser ? JSON.parse(storedUser) : {};
    },
    methods: {
        formatTime(t) {
            if (!t) return '';
            // 兼容时间戳与字符串
            const d = new Date(typeof t === 'number' ? t : String(t).replace(/-/g, '/'));
            if (isNaN(d.getTime())) return '';
            const p = (n) => String(n).padStart(2, '0');
            return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
        },
        getUrl(url) {
            return url ? resourceUrl + url : '';
        },
        handleLogout() {
            this.$dialog.confirm({
                title: '提示',
                message: '确定退出登录？'
            }).then(() => {
                window.sessionStorage.removeItem('token');
                window.sessionStorage.removeItem('userInfo');
                window.sessionStorage.removeItem('userCode');
                this.$toast.success('已退出登录');
                this.$router.push('/');
            }).catch(() => {});
        }
    }
}
</script>

<style scoped>
.mine-page {
    min-height: 100vh;
    background: #f4f6f9;
    padding-bottom: 80px;
    box-sizing: border-box;
}

/* 个人信息头部 */
.profile-hero {
    background: linear-gradient(135deg, #1989fa 0%, #4ba8ff 100%);
    padding: 48px 22px 64px;
    border-radius: 0 0 22px 22px;
    position: relative;
}
.profile-content {
    display: flex;
    align-items: center;
    gap: 16px;
}
.avatar-wrap {
    flex-shrink: 0;
    padding: 3px;
    background: rgba(255, 255, 255, 0.35);
    border-radius: 50%;
}
.avatar {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    object-fit: cover;
    display: block;
    border: 2px solid #fff;
}
.profile-meta {
    flex: 1;
    min-width: 0;
}
.user-name {
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    letter-spacing: 0.5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 8px;
}
.role-chip {
    display: inline-block;
    padding: 3px 10px;
    background: rgba(255, 255, 255, 0.22);
    color: #fff;
    font-size: 12px;
    border-radius: 11px;
    line-height: 1.6;
}

/* 基本信息卡 */
.info-card {
    background: #fff;
    border-radius: 14px;
    margin: -40px 12px 12px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
    position: relative;
    z-index: 2;
}
.card-head {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 13px 16px;
    border-bottom: 1px solid #f5f5f5;
}
.card-icon {
    color: #1989fa;
    font-size: 17px;
}
.card-title {
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
}
.card-body {
    padding: 4px 16px 8px;
}
.info-row {
    display: flex;
    align-items: flex-start;
    padding: 13px 0;
    font-size: 14px;
    border-bottom: 1px solid #f7f8fa;
}
.info-row:last-child {
    border-bottom: none;
}
.ir-label {
    color: #969799;
    width: 88px;
    flex-shrink: 0;
}
.ir-value {
    color: #1a1a1a;
    flex: 1;
    text-align: right;
    word-break: break-all;
    line-height: 1.5;
}

/* 退出登录 */
.logout-card {
    background: #fff;
    border-radius: 14px;
    margin: 0 12px 12px;
    padding: 15px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: #ee0a24;
    font-size: 15px;
    font-weight: 500;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04);
    cursor: pointer;
    transition: opacity 0.15s;
}
.logout-card:active {
    opacity: 0.6;
}

/* 版本信息 */
.version-info {
    text-align: center;
    margin-top: 28px;
}
.version-company {
    color: #c8c9cc;
    font-size: 12px;
}
.version-no {
    color: #dcdee0;
    font-size: 11px;
    margin-top: 4px;
}

@media (max-width: 768px) {
    .profile-hero {
        padding: 40px 18px 60px;
    }
    .avatar {
        width: 58px;
        height: 58px;
    }
    .user-name {
        font-size: 18px;
    }
}
</style>
